export class DashboardPendingOrderIntegrationBackendModel {
    start:number = 0
    end:number = 0
    description:string = ''
    total:number = 0

    constructor(d?:Partial<DashboardPendingOrderIntegrationBackendModel>) {
        Object.assign(this, d)
    }
}
